module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-breadcrumb"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: _vm.backPath
      }
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("消息详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list sense-table-ellipsis sense-detail"
  }, [_c('div', {
    staticClass: "sense-notice-detail"
  }, [_c('div', {
    staticClass: "sense-notice-detail-con"
  }, [_c('h3', {
    staticClass: "clearfix"
  }, [_c('b', {
    staticClass: "sense-ellipsis fl"
  }, [_vm._v(_vm._s(_vm.messageDetailObj.title))]), _vm._v(" "), _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.messageDetailObj.createAt))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.messageDetailObj.text)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-629acd36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MessageDetail.vue
// module id = 575
// module chunks = 1